import React from 'react'
import PropTypes from 'prop-types'

const PATH = 'M5 0C4.0111 0 3.0444 0.293245 2.22215 0.842652C1.39991 1.39206 0.759043 2.17295 '
  + '0.380605 3.08658C0.00216642 4.00021 -0.0968502 5.00554 0.0960758 5.97545C0.289002 6.94535 '
  + '0.765206 7.83627 1.46447 8.53553C2.16373 9.23479 3.05465 9.711 4.02455 9.90392C4.99446 '
  + '10.0968 5.99979 9.99783 6.91342 9.6194C7.82705 9.24096 8.60794 8.60009 9.15735 7.77785C9.70675 '
  + '6.9556 10 5.9889 10 5C9.99854 3.67436 9.47129 2.40344 8.53393 1.46607C7.59656 0.528707 6.32564 '
  + '0.0014558 5 0V0ZM5 7.5C4.90111 7.5 4.80444 7.47067 4.72222 7.41573C4.63999 7.36079 4.57591 '
  + '7.2827 4.53806 7.19134C4.50022 7.09998 4.49032 6.99944 4.50961 6.90245C4.5289 6.80546 4.57652 '
  + '6.71637 4.64645 6.64644C4.71637 6.57652 4.80547 6.5289 4.90246 6.50961C4.99945 6.49031 5.09998 '
  + '6.50021 5.19134 6.53806C5.28271 6.5759 5.3608 6.63999 5.41574 6.72221C5.47068 6.80444 5.5 '
  + '6.90111 5.5 7C5.5 7.13261 5.44732 7.25978 5.35355 7.35355C5.25979 7.44732 5.13261 7.5 5 '
  + '7.5ZM5.5 5.5C5.5 5.63261 5.44732 5.75978 5.35355 5.85355C5.25979 5.94732 5.13261 6 5 6C4.86739 '
  + '6 4.74022 5.94732 4.64645 5.85355C4.55268 5.75978 4.5 5.63261 4.5 5.5V3C4.5 2.86739 4.55268 '
  + '2.74021 4.64645 2.64645C4.74022 2.55268 4.86739 2.5 5 2.5C5.13261 2.5 5.25979 2.55268 5.35355 '
  + '2.64645C5.44732 2.74021 5.5 2.86739 5.5 3V5.5Z'

const ExclamationCircleIcon = ({ className }) => (
  <svg className={className} fill="none" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
    <path d={PATH} fill="currentColor" />
  </svg>
)

ExclamationCircleIcon.propTypes = {
  className: PropTypes.string
}

ExclamationCircleIcon.defaultProps = {
  className: 'tw:h-3 tw:w-3'
}

export default ExclamationCircleIcon
